import React, { useState, useEffect, useContext } from 'react';
import { createTutorial, updateTutorial } from '../api/api';
import '../index.css';
import './UserForm.css'; //Se usa el mismo css
import { AuthContext } from '../context/AuthContext';
import Form from './common/Form';
import Input from './common/Input';
import Select from './common/Select';
import Button from './common/Button';
import Error from './common/Error';


const TutorialForm = ({ tutorial, onClose, onTutorialUpdated, onTutorialCreated }) => {
    const { userRole } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        title: '',
        topic: '',
        text: '',
        type: 'tutorial', // Valor por defecto
        url: '', // Valor por defecto
        file: null, // Nuevo campo para el archivo
        accompaniment: false, // Valor por defecto
    });
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (tutorial) {
            setIsEditing(true);
            setFormData({ ...tutorial, file: null });//Se añade que el file sea null al editar.
        }
    }, [tutorial]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData({ ...formData, [name]: checked });
        }
        else if (type === 'file') {
            setFormData({ ...formData, [name]: e.target.files[0] });
        }
        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        const formDataToSend = new FormData();
        formDataToSend.append('title', formData.title);
        formDataToSend.append('topic', formData.topic);
        formDataToSend.append('text', formData.text);
        formDataToSend.append('type', formData.type);
        formDataToSend.append('url', formData.url); //Se ha añadido esto
        formDataToSend.append('accompaniment', formData.accompaniment); //Se ha añadido esto
        if (formData.type === 'infography') {
            if (formData.file) {
                formDataToSend.append('file', formData.file);
            } else if (tutorial && tutorial.file_path) { //Si tiene una ruta de archivo, se añade
                formDataToSend.append('file', "");
            } else {
                setError("El archivo es necesario para las infografías")
                return;
            }
        }

        try {
            if (isEditing) {
                const updatedTutorial = await updateTutorial(tutorial.id, formDataToSend);
                if (updatedTutorial) {
                    onTutorialUpdated(updatedTutorial);
                }
                setMessage("Tutorial actualizado")
                setTimeout(() => {
                    onClose();
                }, 1500);
            } else {
                const newTutorial = await createTutorial(formDataToSend);
                onTutorialCreated(newTutorial);
                setMessage("Tutorial creado")
                setTimeout(() => {
                    onClose();
                }, 1500);
            }
        } catch (err) {
            setError(err.message || 'Error al procesar el tutorial'); // Mostrar el mensaje del backend
        }
    };

    return (
        <Form className='form-user' onSubmit={handleSubmit}>
            {message && <div className='container-message'>{message}</div>}
            {error && <Error error={error} />}
            <Input type="text" id="title" name="title" value={formData.title} onChange={handleChange} label="Título" required />
            <Input type="text" id="topic" name="topic" value={formData.topic} onChange={handleChange} label="Tema" required />
            <Input type="text" id="text" name="text" value={formData.text} onChange={handleChange} label="Texto" required />
            <Select id="type" name="type" value={formData.type} onChange={handleChange} label="Tipo" required options={[
                { value: "tutorial", label: "Tutorial" },
                { value: "infography", label: "Infografía" },
            ]} />
            {formData.type === 'tutorial' ? (
                <Input type="text" id="url" name="url" value={formData.url} onChange={handleChange} label="URL" required={formData.type === 'tutorial'} />
            ) : (
                <Input type="file" id="file" name="file" onChange={handleChange} label="Archivo" required={formData.type === 'infography'} />
            )}
            <div>
                <label htmlFor="accompaniment">Acompañamiento</label>
                <input type="checkbox" id="accompaniment" name="accompaniment" checked={formData.accompaniment} onChange={handleChange} />
            </div>
            <Button type="submit">{isEditing ? 'Actualizar' : 'Crear'}</Button>
            <Button type='button' onClick={onClose}>Cancelar</Button>
        </Form>
    );
};

export default TutorialForm;
